angular.module('nv.HelpDeskModule.controllers', []);
